<script setup>
import { useI18n } from 'vue-i18n'
import { computed } from 'vue';
import { useCompanyStore } from "@dutypay/store-modules";
import 'element-plus/es/components/select/style/css';
import 'element-plus/es/components/option/style/css';

const { t } = useI18n()
import { useRouter } from 'vue-router';

const { router } = useRouter();
const companyStore = useCompanyStore();

const showReminder = computed(() => {
  return !companyStore.hasSelectedCompany && companyStore.areCompaniesFetched && companyStore.hasCompanies;
});

</script>

<script>
export default {
  name: "ReminderSelectCompany"
}
</script>

<template>
  <DpReminder v-if="showReminder"
              :headline="t('headline.label')"
              :description="t('description.label')"
              :closable="false">
    <template #extraContent>
      <div class="text-align-center" style="margin: 2rem 1rem;">
        <DpSelectCompanySwitch popper-class="reminder__select-company__select__popper-dropdown"
                               v-on:switch="router.go(0)"/>
      </div>
    </template>
  </DpReminder>
</template>

<style scoped lang="scss">
</style>

<i18n>
{
  "ar-AE": {
    "headline": {
      "label": "الرجاء تحديد شركة"
    },
    "description": {
      "label": "اختر شركة تم تخصيصها لحساب المستخدم الخاص بك."
    }
  },
  "ar-EG": {
    "headline": {
      "label": "الرجاء تحديد شركة"
    },
    "description": {}
  },
  "ar-SA": {
    "headline": {
      "label": "الرجاء تحديد شركة"
    },
    "description": {}
  },
  "el-GR": {
    "headline": {
      "label": "Επιλέξτε εταιρεία"
    },
    "description": {
      "label": "Επιλέξτε μια εταιρεία που έχει αντιστοιχιστεί στο λογαριασμό χρήστη σας."
    }
  },
  "el-CY": {
    "headline": {
      "label": "Επιλέξτε εταιρεία"
    },
    "description": {
      "label": "Επιλέξτε μια εταιρεία που έχει αντιστοιχιστεί στο λογαριασμό χρήστη σας."
    }
  },
  "de-DE": {
    "headline": {
      "label": "Unternehmen auswählen"
    },
    "description": {
      "label": "Wähle ein Unternehmen, dass deinem Benutzerkonto zugewiesen ist."
    }
  },
  "de-AT": {
    "headline": {
      "label": "Unternehmen auswählen"
    },
    "description": {
      "label": "Wähle ein Unternehmen, dass deinem Benutzerkonto zugewiesen ist."
    }
  },
  "de-CH": {
    "headline": {
      "label": "Unternehmen auswählen"
    },
    "description": {
      "label": "Wähle ein Unternehmen, dass deinem Benutzerkonto zugewiesen ist."
    }
  },
  "en-US": {
    "headline": {
      "label": "Please select a company"
    },
    "description": {
      "label": "Choose a company that is assigned to your user account."
    }
  },
  "en-GB": {
    "headline": {
      "label": "Select a company"
    },
    "description": {
      "label": "Choose a company that is assigned to your user account."
    }
  },
  "it-IT": {
    "headline": {
      "label": "Seleziona un'azienda"
    },
    "description": {
      "label": "Scegli un'azienda assegnata al tuo account utente."
    }
  },
  "fr-FR": {
    "headline": {
      "label": "Veuillez sélectionner une entreprise"
    },
    "description": {
      "label": "Choisissez une société attribuée à votre compte utilisateur."
    }
  },
  "es-ES": {
    "headline": {
      "label": "Seleccione una empresa"
    },
    "description": {
      "label": "Elija una empresa que esté asignada a su cuenta de usuario."
    }
  },
  "pl-PL": {
    "headline": {
      "label": "Wybierz firmę"
    },
    "description": {
      "label": "Wybierz firmę, która jest przypisana do Twojego konta użytkownika."
    }
  },
  "nl-NL": {
    "headline": {
      "label": "Selecteer een bedrijf"
    },
    "description": {
      "label": "Kies een bedrijf dat is toegewezen aan uw gebruikersaccount."
    }
  },
  "bg-BG": {
    "headline": {
      "label": "Моля, изберете фирма"
    },
    "description": {
      "label": "Изберете компания, която е присвоена на вашия потребителски акаунт."
    }
  },
  "bs-BA": {
    "headline": {
      "label": "Molimo odaberite kompaniju"
    },
    "description": {
      "label": "Izaberite kompaniju koja je dodijeljena vašem korisničkom računu."
    }
  },
  "da-DK": {
    "headline": {
      "label": "Vælg et firma"
    },
    "description": {
      "label": "Vælg et firma, der er tildelt din brugerkonto."
    }
  },
  "et-EE": {
    "headline": {
      "label": "Valige ettevõte"
    },
    "description": {
      "label": "Valige ettevõte, mis on määratud teie kasutajakontole."
    }
  },
  "fi-FI": {
    "headline": {
      "label": "Valitse yritys"
    },
    "description": {
      "label": "Valitse yritys, joka on määritetty käyttäjätilillesi."
    }
  },
  "he-IL": {
    "headline": {
      "label": "אנא בחר חברה"
    },
    "description": {
      "label": "בחר חברה שמוקצה לחשבון המשתמש שלך."
    }
  },
  "ga-IE": {
    "headline": {
      "label": "Roghnaigh cuideachta le do thoil"
    },
    "description": {
      "label": "Roghnaigh cuideachta atá sannta do do chuntas úsáideora."
    }
  },
  "ja-JP": {
    "headline": {
      "label": "会社を選択してください"
    },
    "description": {
      "label": "ユーザーアカウントに割り当てられている会社を選択してください。"
    }
  },
  "hr-HR": {
    "headline": {
      "label": "Odaberite tvrtku"
    },
    "description": {
      "label": "Odaberite tvrtku koja je dodijeljena vašem korisničkom računu."
    }
  },
  "lv-LV": {
    "headline": {
      "label": "Lūdzu, izvēlieties uzņēmumu"
    },
    "description": {
      "label": "Izvēlieties uzņēmumu, kas piešķirts jūsu lietotāja kontam."
    }
  },
  "lt-LT": {
    "headline": {
      "label": "Pasirinkite įmonę"
    },
    "description": {
      "label": "Pasirinkite įmonę, kuri priskirta jūsų vartotojo paskyrai."
    }
  },
  "pt-PT": {
    "headline": {
      "label": "Selecione uma empresa"
    },
    "description": {
      "label": "Escolha uma empresa atribuída à sua conta de usuário."
    }
  },
  "ro-RO": {
    "headline": {
      "label": "Vă rugăm să selectați o companie"
    },
    "description": {
      "label": "Alegeți o companie care este alocată contului dvs. de utilizator."
    }
  },
  "ru-RU": {
    "headline": {
      "label": "Пожалуйста, выберите компанию"
    },
    "description": {
      "label": "Выберите компанию, которая привязана к вашей учетной записи."
    }
  },
  "sv-SE": {
    "headline": {
      "label": "Välj ett företag"
    },
    "description": {
      "label": "Välj ett företag som tilldelats ditt användarkonto."
    }
  },
  "sk-SK": {
    "headline": {
      "label": "Vyberte spoločnosť"
    },
    "description": {
      "label": "Vyberte spoločnosť, ktorá je priradená k vášmu používateľskému účtu."
    }
  },
  "cs-CZ": {
    "headline": {
      "label": "Vyberte společnost"
    },
    "description": {
      "label": "Vyberte společnost, která je přiřazena k vašemu uživatelskému účtu."
    }
  },
  "hu-HU": {
    "headline": {
      "label": "Válasszon egy vállalatot"
    },
    "description": {
      "label": "Válasszon egy vállalatot, amely a felhasználói fiókjához van hozzárendelve."
    }
  },
  "fr-BE": {
    "headline": {
      "label": "Veuillez sélectionner une entreprise"
    },
    "description": {
      "label": "Choisissez une société attribuée à votre compte utilisateur."
    }
  },
  "fr-LU": {
    "headline": {
      "label": "Veuillez sélectionner une entreprise"
    },
    "description": {
      "label": "Choisissez une société attribuée à votre compte utilisateur."
    }
  },
  "mt-MT": {
    "headline": {
      "label": "Jekk jogħġbok agħżel kumpanija"
    },
    "description": {
      "label": "Agħżel kumpanija li hija assenjata għall-kont tal-utent tiegħek."
    }
  },
  "sl-SI": {
    "headline": {
      "label": "Izberite podjetje"
    },
    "description": {
      "label": "Izberite podjetje, ki je dodeljeno vašemu uporabniškemu računu."
    }
  },
  "tr-TR": {
    "headline": {
      "label": "Lütfen bir şirket seçin"
    },
    "description": {
      "label": "Kullanıcı hesabınıza atanmış bir şirket seçin."
    }
  },
  "tr-CY": {
    "headline": {
      "label": "Lütfen bir şirket seçin"
    },
    "description": {
      "label": "Kullanıcı hesabınıza atanmış bir şirket seçin."
    }
  },
  "uk-UA": {
    "headline": {
      "label": "Виберіть компанію"
    },
    "description": {}
  },
  "zh-CN": {
    "headline": {
      "label": "请选择公司"
    },
    "description": {
      "label": "选择分配给您的用户帐户的公司。"
    }
  }
}
</i18n>
